module.exports = __webpack_public_path__ + "media/ק.ee858619.mp3";